// extracted by mini-css-extract-plugin
module.exports = {"ButtonArea":"SubtypeList_ButtonArea__p8OaJ","TodoTemplateCol":"SubtypeList_TodoTemplateCol__lPcev","ButtonCol":"SubtypeList_ButtonCol__rw_B6"};